/**
 *
 * Asynchronously loads the component for HubSpotLogs
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
